import { createAction } from '@reduxjs/toolkit'
import { call, fork, ForkEffect, put, select, takeEvery } from 'redux-saga/effects'

import { pollProjectForRegionUpdate } from '../effects/pollProjectForRegionUpdate'
import { createRegion as saveRegion, fetchOpeningGroupsByProjectIdWithDefault } from '../../../api/takeoff-api'
import { OpeningGroupAPI } from '../../../models/activeDrawable'
import { Project } from '../../../models/project'
import { Region } from '../../../models/region'
import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import { Workspace } from '../../lib/toolBoxes/2D'
import { selectProject } from '../../slices/project'
import { addRegionToStore } from '../../slices/region'

export const createRegionAction = createAction<{ newRegion: Omit<Region, 'id'>; paperId: number }>('createRegion')

export function* handleCreateRegion({ payload }: ReturnType<typeof createRegionAction>) {
    const paperManager: PaperManager | null = yield call(managers.get2DManager)

    if (!paperManager) return

    try {
        const project: Project = yield select(selectProject)
        const openingGroups: OpeningGroupAPI[] = yield call(fetchOpeningGroupsByProjectIdWithDefault, project.id)
        const workspaceTool: Workspace = yield call(paperManager.getTool, Workspace.NAME)

        const response = yield call(saveRegion, project.id, payload.newRegion)

        const newRegion: Region = {
            id: response.id,
            name: response.name,
            type: response.type,
            scale: response.scale,
            coordinates: response.coordinates,
            document_chunk_id: response.document_chunk_id,
        }

        // We have to assign the id to the region once it has been created
        const regionPaperItem: paper.PathItem = yield call(workspaceTool.getItemWithPaperId, payload.paperId)

        regionPaperItem.data.region_id = response.id
        regionPaperItem.data.scale = payload.newRegion.scale

        yield put(addRegionToStore(newRegion))

        yield fork(
            pollProjectForRegionUpdate,
            'Recalculating measurements…',
            5000,
            openingGroups,
            false,
            response.id,
            response.coordinates
        )
    } catch (error) {
        yield call(console.error, error)
    }
}

export function* watchForCreateRegion(): Generator<ForkEffect<never>, void, unknown> {
    yield takeEvery(createRegionAction.type, handleCreateRegion)
}
